export default __webpack_public_path__ + "static/media/151-skyline.a86b070c.png";